// Dashboard.jsx
import React, { useEffect, useState , useMemo } from 'react';
import { FaCubes, FaFilePdf } from "react-icons/fa";
import useIsMobile from '../hooks/useIsMobile';
import PatientCardList from './PatientCardList';

const Dashboard = ({ user, onViewPdf, onViewModel, onBackFromPdf, viewingPdf, appMode }) => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastViewedPatientId, setLastViewedPatientId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  
  const PATIENTS_URL = window.API_BASE_URL + "patients";
  const MODEL_URL = window.API_BASE_URL + "model";
  const PDF_URL = window.API_BASE_URL + "pdf";
  
  useEffect(() => {
    const fetchData = async() => {
try
      {
      const response = await fetch(`${PATIENTS_URL}?doctor_id=${user.physicianId}`);
        
      if(!response.ok){
        if(response.status == 404)
          throw new Error("User Not Found");
        else if(response.status == 401)
          throw new Error("Unautherized");
        else if(response.status == 500)
          throw new Error("Server Error");
      }

      const data = await response.json();

      setPatients(data);
      setLoading(false);
      }
      catch(err){
        console.error("Error fetching patients:", err);
        setLoading(false);
      };
    }
    if(user.role == "Admin")
    {
fetch(`${PATIENTS_URL}`)
      .then(res => res.json())
      .then(data => {
        setPatients(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching patients:", err);
        setLoading(false);
      });
    }
      else
      {
        fetchData();
      }
      const saved = localStorage.getItem("lastViewedPatientId");
      if (saved) setLastViewedPatientId(saved);
  
  }, []);

  
  
  const getDateFromTicks = (dotnetTicks) => {
      if (!dotnetTicks || isNaN(dotnetTicks)) return "-";

      const DOTNET_JAVASCRIPT_EPOCH_DIFFERENCE = 621355968000000000;
      const ticksPerMillisecond = 10000;
      const jsMilliseconds = (dotnetTicks - DOTNET_JAVASCRIPT_EPOCH_DIFFERENCE) / ticksPerMillisecond;

      const date = new Date(jsMilliseconds);

      // Return a formatted string, not a Date object
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
        //hour: "2-digit",
        //minute: "2-digit",
      });
   };  

//  // Filtering: admin sees all, doctor sees only their hospital(s)
//  const filteredPatients = patients.filter(p => {
//    if (user.role === 'admin') return true;
//    if (user.hospitals && user.hospitals.length > 0) {
//      return user.hospitals.some(h => h.id === p.hospital_id);
//    }
//    return false;
//  });


  const filteredPatients = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if(term == '' || term == null)
      return patients;
    else
    {
    return patients.filter((p) => {
      // keep hospital restriction for doctor role
      // const allowed =
      //   user.role === "admin" ||
      //   user.hospitals?.some((h) => h.id === p.hospital_id);
      // if (!allowed) return false;

      // if (!term) return true;

      const inHistory = Array.isArray(p.history)
        ? p.history.some((h) => h?.toLowerCase().includes(term))
        : false;

      const inSurgeryVenue =
        p.surgery_venue && p.surgery_venue.toLowerCase().includes(term);
        
      const inSurgeryType =
        p.surgery_type && p.surgery_type.toLowerCase().includes(term);

      const inSurgeon =
        p.surgeon && p.surgeon.toLowerCase().includes(term);
        
      return (
        (p.pid && p.pid.toLowerCase().includes(term)) ||
        (p.name && p.name.toLowerCase().includes(term)) ||
        (p.first_name && p.first_name.toLowerCase().includes(term)) ||
        (p.last_name && p.last_name.toLowerCase().includes(term)) ||
        (p.hospital_name && p.hospital_name.toLowerCase().includes(term)) ||
        inHistory ||
        inSurgeryVenue ||
        inSurgeryType ||
        inSurgeon
      );
    });
  }
  }, [patients, searchTerm, user]);

  // Detect screen size
  const isMobile = useIsMobile();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-gray-600">Loading patients...</p>
      </div>
    );
  }

  return (
      <div className="max-w-7xl mx-auto bg-white p-6 rounded shadow min-h-full">

<div className="flex items-center justify-between mb-6">
  {/* Left: Hospital logo + Welcome text */}
  <div className="flex items-center gap-4">
    {
      <div className="relative group">
        {/* Small square logo */}
        {/* <img
          src={`/static/logos/${user.hospitals[0].logo_path}`}
          alt="Hospital Logo"
          className="h-20 w-20 object-contain"
        /> */}
        {/* Optional hover-preview (if you like the large preview idea) */}
        <div className="fixed hidden group-hover:block z-50 bg-white p-1 border shadow-lg">
          {/* <img
            src={`/static/logos/${user.hospitals[0].logo_path}`}
            alt="Hospital Logo Large"
            className="max-h-[80vh] max-w-[90vw] object-contain"
          /> */}
        </div>
      </div>
    }

    {/* Welcome text */}
    <div>
      <h2 className="text-2xl font-bold text-gray-800 leading-snug">
          Welcome, {user.name}
      </h2>
      {/*{user.hospitals?.length == 1 && (
        <p className="text-gray-600 text-sm">
          {user.hospitals[0].name}
        </p>
      )}*/}
    </div>
  </div>
          
          
          {viewingPdf && (
            <button
              onClick={onBackFromPdf}
              className="px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-600"
            >
              ← Back to Dashboard
            </button>
          )}
        </div>

        {!viewingPdf && (
          <>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-2">
            <h3 className="text-lg font-semibold text-gray-700">
            Patients <span className="text-gray-500 text-lg">({filteredPatients.length})</span>
            </h3>
            
            {/* 🔍 Search Bar */}
	    {/*<div className="mb-4 flex justify-end sm:justify-end">*/}
	      <input
	        type="text"
	        placeholder="Search patients..."
	        value={searchTerm}
	        onChange={(e) => setSearchTerm(e.target.value)}
	        className="border border-gray-300 rounded-md px-3 py-1 text-sm w-full sm:w-64
	                   focus:outline-none focus:ring-1 focus:ring-cyan-600 focus:border-cyan-600"
	      />
	    </div>

      {/* Conditionally render table or cards based on screen size */}
      {isMobile ? (
        <PatientCardList appMode={appMode} patients={filteredPatients} onViewPdf={onViewPdf} onViewModel={onViewModel} />
      ) : (
        <div className="overflow-x-auto rounded-lg shadow">
              <table className="min-w-full border border-gray-300 text-sm sm:text-base text-gray-700 rounded-lg overflow-hidden"> 
                <thead className="bg-gray-300">
                  <tr>
                    {appMode === "production" ? (
                      <>
                        <th className="px-4 py-2 border">Patient ID</th>
                        <th className="px-4 py-2 border">Name</th>
                        <th className="px-4 py-2 border">Registered Date</th>
                        <th className="px-4 py-2 border">3D Model</th>
                        <th className="px-4 py-2 border">PDF Report</th>                        
                      </>
                    ) : (
                      <>
                        <th className="px-4 py-2 border">OT</th>
                        <th className="px-4 py-2 border">Surgery</th>
                        <th className="px-4 py-2 border">Surgeon Name</th>
                        <th className="px-4 py-2 border">3D Model</th>
                        <th className="px-4 py-2 border">PDF Report</th>
                        <th className="px-4 py-2 border">Patient History</th>
                      </>
                    )}                    

                    
                    
                  </tr>
                </thead>

<tbody className="divide-y divide-gray-200">
  {filteredPatients.map((p) => (
    <tr key={`${p.patient_id}-${p.hospital_id}`}
        onClick={() => {
	    // highlight on any row click
	    setLastViewedPatientId(`${p.patient_id}-${p.hospital_id}`);
	    localStorage.setItem("lastViewedPatientId", `${p.patient_id}-${p.hospital_id}`);
        }}
        className={`hover:bg-gray-50 transition cursor-pointer relative ${
                             lastViewedPatientId === `${p.patient_id}-${p.hospital_id}` ? "bg-yellow-100 font-semibold border-1 border-yellow-500" : ""}`}>

  {/* Left marker 
  {lastViewedPatientId === p.patient_id && (
    <td className="relative px-4 py-2 border">
      <div className="absolute left-0 top-0 h-full w-1 bg-yellow-500"></div>
      {p.pid}
    </td>
  )}

  {lastViewedPatientId !== p.patient_id && (
    <td className="px-4 py-2 border">{p.pid}</td>
  )} */}


  

                    {appMode === "production" ? (
                      <>
                        <td className="relative px-4 py-2 border">
                          {lastViewedPatientId === `${p.patient_id}-${p.hospital_id}` && (
                            <div className="absolute left-0 top-0 h-full w-1 bg-yellow-500"></div>
                          )}
                          {p.pid}
                        </td>
                        {p.first_name || p.last_name ? (
                          <td className="px-4 py-2 border">
                            {p.first_name} {p.last_name}
                          </td>
                        ) : (
                          <td className="px-4 py-2 border">{p.name}</td>
                        )}
                      
                        <td className="px-4 py-2 border text-center">{getDateFromTicks(p.dor)}</td>
                      </>
                    ) : (
                      <>
                        <td className="relative px-4 py-2 text-sm border">
                          {lastViewedPatientId === `${p.patient_id}-${p.hospital_id}` && (
                            <div className="absolute left-0 top-0 h-full w-1 bg-yellow-500"></div>
                          )}
                          {p.surgery_venue}
                        </td>
                        <td className="px-4 py-2 text-sm border text-center">{p.surgery_type}</td>
                        <td className="px-4 py-2 text-sm border text-center">{p.surgeon}</td>
                      </>
                    )}  

      {/* 3D Model */}
      <td className="px-4 py-2 border text-center">
        {p.model_drive_id ? (
          <button
            onClick={(e) => {
              e.stopPropagation(); // prevent row onClick from firing twice
              setLastViewedPatientId(`${p.patient_id}-${p.hospital_id}`);
              localStorage.setItem("lastViewedPatientId", `${p.patient_id}-${p.hospital_id}`);
              
              onViewModel({
                patientId: p.patient_id,
                patientName:
                  p.first_name || p.last_name
                    ? `${p.first_name} ${p.last_name}`
                    : p.name,
                modelUrl: `${MODEL_URL}/${p.model_drive_id}`,
                studyDate: getDateFromTicks(p.dor),
              });
            }}
            className="flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 
                       rounded-md hover:bg-blue-200 text-xs font-medium shadow-sm mx-auto"
            title="View 3D Uterus Model"
          >
            <FaCubes className="text-xs" /> Model
          </button>
        ) : (
          <span className="text-gray-400 text-xs">No model</span>
        )}
      </td>

      {/* PDF Report */}
      <td className="px-4 py-2 border text-center">
        {p.pdf_drive_id ? (
          <button
            onClick={(e) => {
              e.stopPropagation(); // prevent row onClick from firing twice
              setLastViewedPatientId(`${p.patient_id}-${p.hospital_id}`);
              localStorage.setItem("lastViewedPatientId", `${p.patient_id}-${p.hospital_id}`);
              onViewPdf({
                patientId: p.patient_id,
                fileId: p.pdf_drive_id,
                pdfUrl: `${PDF_URL}/${p.pdf_drive_id}`,
              });
            }}
            className="flex items-center gap-1 px-2 py-1 bg-red-100 text-red-700 
                       rounded-md hover:bg-red-200 text-xs font-medium shadow-sm mx-auto"
            title="View PDF Report"
          >
            <FaFilePdf className="text-xs" /> PDF
          </button>
        ) : (
          <span className="text-gray-400 text-xs">No PDF</span>
        )}
      </td>
      
                          {appMode === "production" ? (
                            <>
                            </>
                          ) : (
                            <>
                              <td className="px-4 py-2 border">
                                <ul className="list-disc list-inside text-sm text-gray-700">
     			          {p.history && p.history.map((h, i) => (
			            <li key={i}>{h}</li>
			          ))}
                                </ul>
                              </td>                            
                            </>
                         )}  


    </tr>
  ))}

  {filteredPatients.length === 0 && (
    <tr>
      <td
        colSpan="6"
        className="px-4 py-4 text-center text-gray-500"
      >
        No patients found.
      </td>
    </tr>
  )}
</tbody>


              </table>
        </div>
      )}
          </>
        )}
      </div>
  );
};

export default Dashboard;
